import TextCell from 'components/TextCell';
import type { ManagedOemSegmentType } from '../..';

interface CellProps {
  rowData: ManagedOemSegmentType;
}

export default function NameCell({ rowData: { name } }: CellProps) {
  return <TextCell text={name} />;
}
